export default __webpack_public_path__ + "static/media/feature-tile-icon-02.46935659.svg";